import { z } from "zod";

const API_URL = "http://127.0.0.1:8000";

// Schemas for API responses
const UserProfileSchema = z.object({
  name: z.string(),
  email: z.string().email(),
  age: z.number(),
  weight: z.number(),
  height: z.number(),
});

const HealthRiskSchema = z.object({
  risk_score: z.number(),
  risk_level: z.enum(["Low", "Moderate", "High"]),
});

const RecommendationSchema = z.object({
  recommendation: z.string(),
});

const NutritionSchema = z.object({
  calories: z.string(),
  food_focus: z.string(),
  meal_suggestions: z.array(z.string()),
});

const getAuthToken = () => {
  return localStorage.getItem("token");
};

// API functions

export const getUserProfile = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/users/me/`, {
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch user profile");
  }
  const data = await response.json();
  return UserProfileSchema.parse(data);
};

export const updateUserProfile = async (profileData: z.infer<typeof UserProfileSchema>) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/profile`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(profileData),
  });
  if (!response.ok) {
    throw new Error("Failed to update user profile");
  }
  return await response.json();
};

export const getHealthRisk = async (healthData: any) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/predict`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(healthData),
  });
  if (!response.ok) {
    throw new Error("Failed to get health risk");
  }
  const data = await response.json();
  return HealthRiskSchema.parse(data);
};

export const getRecommendation = async (recData: any) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/recommend`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(recData),
  });
  if (!response.ok) {
    throw new Error("Failed to get recommendation");
  }
  const data = await response.json();
  return RecommendationSchema.parse(data);
};

export const getNutritionPlan = async (nutData: any) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/nutrition`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(nutData),
  });
  if (!response.ok) {
    throw new Error("Failed to get nutrition plan");
  }
  const data = await response.json();
  return NutritionSchema.parse(data);
};